import { render, staticRenderFns } from "./BlackListAdminView.vue?vue&type=template&id=e7201936&scoped=true"
import script from "./BlackListAdminView.vue?vue&type=script&lang=js"
export * from "./BlackListAdminView.vue?vue&type=script&lang=js"
import style0 from "./BlackListAdminView.vue?vue&type=style&index=0&id=e7201936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7201936",
  null
  
)

export default component.exports